import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ORDER_CANDIDATES } from '../../../../define/consts/solution';
import { propFunc, propStr } from '../../../../helpers/custom-prop-types';
const SearchSort = ({ changeSort, currentOrder }) => (_jsx("div", Object.assign({ className: 'right-top-menu' }, { children: ORDER_CANDIDATES.map(({ label, value }) => (_jsx("button", Object.assign({ className: `sort ${value === currentOrder ? 'is-select' : ''}`, onClick: changeSort, type: 'button', value: value }, { children: label }), value))) })));
SearchSort.propTypes = {
    changeSort: propFunc().isRequired,
    currentOrder: propStr().isRequired,
};
export default SearchSort;
